import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../types/paths';

export const Home: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/${PATHS.LOGIN}`);
  }, [navigate]);

  return <></>;
};
